export const currencySchema = `
            id
            date
            currencyCode
            currencyName     
            countryCode
            countryName
            buyFxRate
            sellFxRate
            from
            to
    `;
